export type FeatureName =
  | 'ROLEPLAY'
  | 'MEETING_RECORDING'
  | 'ROLEPLAY_CAPTIONS'
  | 'BLUE_BEAN_INTEGRATION'
  | 'KAIKURA_INTEGRATION'
  | 'BIZTEL_INTEGRATION'
  | 'AMAZON_CONNECT_INTEGRATION'
  | 'TRYGROUP_DASHBOARD'
  | 'SKIP_AI_EVALUATION'
  | 'ROLEPLAY_LOW_LATENCY'

/**
 * DB から取得した enabledFeatures に指定フィーチャーが含まれるかチェックする
 */
export function isFeatureAllowed(
  featureName: FeatureName,
  enabledFeatures: string[] | undefined,
): boolean {
  if (!enabledFeatures) return false
  return enabledFeatures.includes(featureName)
}
